import { Injectable } from "@angular/core";
import { CanActivate, Router } from "@angular/router";
import { AuthService } from "../services/auth.service";
import { UserFacade } from "../store/facade/user.facade";
import { filter, map } from "rxjs/operators";
import { combineLatest, Observable, of } from "rxjs";
import { ERROR } from "../variables/uri";

@Injectable({
    providedIn: "root",
})
export class AuthGuard implements CanActivate {
    constructor(
        private authService: AuthService,
        private userFacade: UserFacade,
        private router: Router,
    ) {}

    canActivate(): Observable<boolean> {
        if (!this.authService.isLoggedIn()) {
            this.router.navigate([ERROR.NOT_AUTHENTICATED]);
            return of(false);
        }

        return combineLatest([
            this.userFacade.user$,
            this.userFacade.loading$,
        ]).pipe(
            filter(([, loading]) => !loading),
            map(([user]) => {
                if (user) {
                    return true;
                } else {
                    this.router.navigate([ERROR.NOT_AUTHENTICATED]);
                    return false;
                }
            }),
        );
    }
}
